import { Subject } from 'rxjs';
import { UserService } from '../shared/services/user.service';
/**
 * Pages component
 */
var PagesComponent = (function () {
    function PagesComponent(userService) {
        var _this = this;
        this.companyID = '';
        this.ngUnsubscribe = new Subject();
        userService.currentUser.takeUntil(this.ngUnsubscribe).subscribe(function (user) {
            if (!user) {
                return;
            }
            _this.companyID = user.company._id;
        });
    }
    /**
     * On destroy cancel active subscriptions
     */
    PagesComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    PagesComponent.prototype.getCompanyClass = function () {
        var classes = {};
        if (this.companyID) {
            classes['b2a-company-' + this.companyID] = true;
        }
        return classes;
    };
    return PagesComponent;
}());
export { PagesComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/pages.component.ts.pre-build-optimizer.js